var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!this.$slots.default ? 'text-center': 'button-grid'},[_vm._t("default",[_vm._v("Empty")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }